<template>
    <q-select
        :dark="$store.state.darkMode"
        class="regularFontSize color__blackOnDisabled"
        outlined
        dense
        use-input
        options-dense
        :options-dark="$store.state.darkMode"
        :disable="disable"
        :label="label"
        :options="filteredSearchedOptions"
        v-model="input"
        @input="onChange"
        :error="error"
        no-error-icon
        hide-hint
        hide-bottom-space
        :loading="loading"
        @popup-show="focusSearchInput"
        :rules="rules"
        :menu-anchor="'bottom left'"
        :menu-self="'top left'"
        behavior="dialog"
        popup-content-class="sam-select-popup regularFontSize"
    >
        <template v-if="input" v-slot:append>
            <q-icon size="xs" style="color: lightgray" name="cancel" @click.stop.prevent="clearFields" class="cursor-pointer" />
        </template>
        <template v-slot:before-options>
            <q-item class="search-option-field">
                <q-item-section>
                    <q-input v-model="filterValue" ref="searchInputBefore" dense outlined clearable :placeholder="`Search ${label} ...`" @click.stop>
                        <template v-slot:prepend>
                            <q-icon name="search" />
                        </template>
                    </q-input>
                </q-item-section>
            </q-item>

            <q-separator />
        </template>
        <template v-slot:no-option>
            <q-item class="search-option-field">
                <q-item-section>
                    <q-input
                        v-model="filterValue"
                        ref="searchInputNoOption"
                        dense
                        outlined
                        clearable
                        :placeholder="`Search ${label} ...`"
                        @click.stop
                    >
                        <template v-slot:prepend>
                            <q-icon name="search" />
                        </template>
                    </q-input>
                </q-item-section>
            </q-item>
            <q-separator />
            <q-item>
                <q-item-section class="text-grey"> No results </q-item-section>
            </q-item>
        </template>
    </q-select>
</template>

<script>
export default {
    props: ['disable', 'label', 'model', 'value', 'options', 'error', 'loading', 'rules'],
    mounted() {
        this.input = this.value;
        this.customOptions = this.options;
        this.filteredOptions = this.customOptions;
    },
    data() {
        return {
            input: '',
            filteredOptions: [],
            customOptions: [],
            regionSearch: '',
            filterValue: '',
        };
    },
    methods: {
        clearFields() {
            this.input = '';
            this.$emit('change', this.model, this.input);
        },
        onChange() {
            this.$emit('change', this.model, this.input);
            if (this.label.toLowerCase().includes('warehouse')) {
                this.$emit('input', this.input);
            }
        },
        focusSearchInput() {
            const focusInput = () => {
              const input = this.$refs.searchInputBefore || this.$refs.searchInputNoOption;

                if (!input) {
                    return;
                }

                // QInput ka actual native input
                const el = input.$el.querySelector('input');

                if (el) {
                    el.focus();
                    el.select();
                }
            };

            // Quasar popup/dialog render hone ka wait
            this.$nextTick(() => {
                setTimeout(focusInput, 300);
            });
        },

        filterElements(val, update) {
            if (this.regionSearch.trim() === '') {
                update(() => {
                    this.customOptions = this.filteredOptions;
                });
            } else {
                update(() => {
                    const needle = this.regionSearch.toLowerCase();
                    this.customOptions = this.filteredOptions?.filter((v) => v.toLowerCase().indexOf(needle) > -1);
                });
            }
        },

        setoptions(setopt) {
            this.customOptions = setopt || [];
        },

        setValue(val) {
            this.input = val;
        },
        handleFocus() {
            this.$refs.inputRef.focus();
        },
        required(value) {
            return !!value || 'This field is required';
        },
    },
    computed: {
        filteredSearchedOptions() {
            return this.customOptions
                .map((e) => e)
                .filter(Boolean)
                .filter((name) => !this.filterValue || name.toLowerCase().includes(this.filterValue.toLowerCase()));
        },
    },
    watch: {
        options(newVal) {
            // Update dropdown options
            this.customOptions = newVal;

            // Also update the list used for filtering
            this.filteredOptions = [...newVal];

            // Debug
        },
        value(newVal) {
            this.input = newVal;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/quasar.variables.scss';

::v-deep .sam-select-popup {
    padding: 0 !important;
}

::v-deep .sam-select-popup .search-option-field {
    position: sticky !important;
    top: 0 !important;
    z-index: 9999 !important;
    background: #fff !important;
    padding: 10px !important;
}

.search-option-field {
    position: sticky !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    width: auto !important;
    z-index: 99999 !important;
    background: white !important;
    padding: 10px !important;
}
</style>
